import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function FacilityOrderTemplatePNMissingInformationModalTemplate({ facilityOrderTemplatePNMissingInformationModalStore }) {
    const {
        modalParams,
        missingInformation,
        generate
    } = facilityOrderTemplatePNMissingInformationModalStore;

    return (
        <section>
            <div className="modal__body">
            <p className="u-mar--bottom--sml">Missing Information:</p>
                <div className="form__group u-mar--left--lrg">
                    <ul style={{ listStyleType: 'disc' }}>
                        {
                            missingInformation.map(function (item) {
                                return <li key="">{item}</li>
                            })
                        }
                    </ul>
                </div>
                <p>The PN can be generated without this information, but it will be incomplete.</p>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label="Cancel"
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label="Generate"
                    onClick={() => generate()}
                />
            </div>
        </section>
    )
}

FacilityOrderTemplatePNMissingInformationModalTemplate.propTypes = {
    facilityOrderTemplatePNMissingInformationModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplatePNMissingInformationModalTemplate);
